import loadable from '@loadable/component';

export const OrgDashboardCreditViewContainerLoadable = loadable(
  () => import('./OrgDashboardCreditViewContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardCreditViewContainer,
    ssr: false,
  },
);
